import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

class Statements {

    async GetStatements(requestBody) {

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";


        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        let gatewayRequest = {
            "strEndpointName" : "EstadoCuenta",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }

        await axios.post(APIurl, gatewayRequest, config)
        .then(response => {
            result = JSON.parse(response.data);
        })
        .catch(error => console.error(error));
        return result;
    }
}

module.exports = Statements;
